import { GridService, IGridService } from '../shared/grid/grid.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IhLabResult } from '../models/IhLabResult.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class IhLabResultService extends GridService<IhLabResult> implements IGridService<IhLabResult> {

    constructor(http: HttpClient) {
        super('IhLabResult', http);
    }

    createManualLabResult(payload): Observable<any> {
        return this.http.post<any>(this.getApiUrl(`${this.controllerName}/CreateManualLabResult`), payload);
    }
}
